/**
 * Toast notification component
 * Shows temporary notification messages (success, error, info, warning)
 */

import React, { useEffect, useState } from "react";
import "./Toast.scss";

export interface ToastProps {
  message: string;
  type?: "success" | "error" | "info" | "warning";
  duration?: number;
  onClose?: () => void;
}

export const Toast: React.FC<ToastProps> = ({
  message,
  type = "info",
  duration = 3000,
  onClose,
}) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
      setTimeout(() => onClose?.(), 300); // Wait for fade-out animation
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  if (!isVisible) return null;

  return (
    <div className={`toast toast-${type} ${isVisible ? "toast-visible" : ""}`}>
      <div className="toast-content">
        <span className="toast-icon">{getIcon(type)}</span>
        <span className="toast-message">{message}</span>
      </div>
    </div>
  );
};

function getIcon(type: string): string {
  switch (type) {
    case "success": return "✓";
    case "error": return "✕";
    case "warning": return "⚠";
    case "info":
    default: return "ℹ";
  }
}
